interface ErrorScreenProps {
  title: string;
  message: string;
  error?: Error | null;
  onRetry?: () => void;
}

export function ErrorScreen({ title, message, error, onRetry }: ErrorScreenProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="max-w-md w-full text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 mb-4 bg-red-100 rounded-full">
          <svg
            className="w-8 h-8 text-red-500"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"
            />
          </svg>
        </div>
        <h2 className="text-xl font-semibold text-gray-900 mb-2">{title}</h2>
        <p className="text-gray-600 mb-4">{message}</p>

        {error && (
          <details className="text-left bg-gray-100 rounded-lg p-3 mb-4">
            <summary className="text-sm font-medium text-gray-700 cursor-pointer">
              Error details
            </summary>
            <pre className="mt-2 text-xs text-gray-600 overflow-auto">{error.message}</pre>
          </details>
        )}

        {onRetry && (
          <button onClick={onRetry} className="btn btn-primary">
            Try Again
          </button>
        )}
      </div>
    </div>
  );
}
